/**
 * Stats props to display as notifications
 */
export enum NotificationStatProp {
  NewApplications = 'newApplications',
  NewMessages = 'newMessages',
}
